import { render } from "./FileContentComponent.vue?vue&type=template&id=3ef93bc0&scoped=true"
import script from "./FileContentComponent.vue?vue&type=script&lang=js"
export * from "./FileContentComponent.vue?vue&type=script&lang=js"

import "./FileContentComponent.vue?vue&type=style&index=0&id=3ef93bc0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef93bc0"]])

export default __exports__